import { render, staticRenderFns } from "./data-table-review.vue?vue&type=template&id=66ea40d8&"
import script from "./data-table-review.vue?vue&type=script&lang=ts&"
export * from "./data-table-review.vue?vue&type=script&lang=ts&"
import style0 from "./data-table-review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports